// jobTemplates.js — job-type checklist templates (spec §2.2).
//
// Templates are DATA, not bespoke components: the job-sheet detail screen
// renders `items` as plain checkboxes and stores the result in
// engineer_job_sheets.form_data (same principle as certificate form_data).
// v1 ships one shared generic template + a boiler-service template; more
// types are just more entries here.

export const JOB_TYPES = [
  { value: 'boiler_service', label: 'Boiler Service', icon: 'Zap' },
  { value: 'radiator_install', label: 'Radiator Install', icon: 'Tool' },
  { value: 'gas_safety', label: 'Gas Safety Check', icon: 'Shield' },
  { value: 'maintenance', label: 'Maintenance', icon: 'Wrench' },
  { value: 'other', label: 'Other / General', icon: 'Clipboard' },
];

export const JOB_TYPE_LABELS = Object.fromEntries(
  JOB_TYPES.map((t) => [t.value, t.label]),
);

export const JOB_TEMPLATES = {
  boiler_service: {
    checklist: [
      'Visual inspection of boiler and flue',
      'Check gas pressure and burner pressure',
      'Check flue gases (CO/CO₂ ratio)',
      'Inspect and clean heat exchanger',
      'Check and reset safety devices',
      'Inspect expansion vessel pressure',
      'Check condensate trap and pipework',
      'Test boiler operation and controls',
      'Check thermostat and programmer',
      'Check radiators and bleed as needed',
    ],
    notesHint: 'Record pressures, flow temperatures and any defects found.',
  },
  radiator_install: {
    checklist: [
      'Drain system and isolate pipework',
      'Remove old radiator and brackets',
      'Fit new radiator and bleed valve',
      'Re-fill system and check pressure',
      'Bleed radiator and check TRV operation',
      'Test for leaks on all joints',
      'Balance system and check heat distribution',
    ],
    notesHint: 'Note radiator size, TRV type and system pressure after fill.',
  },
  gas_safety: {
    checklist: [
      'Check appliance for signs of distress/leaks',
      'Verify gas tightness (let-by test)',
      'Check flue flow and integrity',
      'Check ventilation to appliance',
      'Verify flame picture and burner pressure',
      'Check CO levels in ambient air',
      'Confirm gas safe register details match',
    ],
    notesHint: 'Record tightness test time and standing pressure.',
  },
  maintenance: {
    checklist: [
      'Inspect system and identify any faults',
      'Check system pressure and top up',
      'Check boiler operation',
      'Check radiators and pipework',
      'Lubricate/service moving parts',
      'Test all controls',
      'Report condition and recommendations',
    ],
    notesHint: 'Note parts replaced and any follow-up required.',
  },
  other: {
    checklist: [
      'Inspect the installation',
      'Complete the required work',
      'Test installation is safe and working',
      'Leave site clean and tidy',
    ],
    notesHint: 'Describe the work completed in the notes below.',
  },
};

// Template used when a job type has no specific template (v1 default).
export function templateFor(type) {
  return JOB_TEMPLATES[type] || JOB_TEMPLATES.other;
}
